"use strict";
export var PopupType = /* @__PURE__ */ ((PopupType2) => {
  PopupType2["Transaction"] = "transaction";
  PopupType2["Order"] = "order";
  PopupType2["FailedSwitchNetwork"] = "failedSwitchNetwork";
  PopupType2["SwitchNetwork"] = "switchNetwork";
  PopupType2["Bridge"] = "bridge";
  PopupType2["Mismatch"] = "mismatch";
  PopupType2["FORTransaction"] = "forTransaction";
  return PopupType2;
})(PopupType || {});
export var SwitchNetworkAction = /* @__PURE__ */ ((SwitchNetworkAction2) => {
  SwitchNetworkAction2["Swap"] = "swap";
  SwitchNetworkAction2["Send"] = "send";
  SwitchNetworkAction2["Buy"] = "buy";
  SwitchNetworkAction2["Sell"] = "sell";
  SwitchNetworkAction2["Limit"] = "limit";
  SwitchNetworkAction2["LP"] = "lp";
  SwitchNetworkAction2["PoolFinder"] = "poolFinder";
  return SwitchNetworkAction2;
})(SwitchNetworkAction || {});
